export default "__VITE_ASSET__fe9a1613__"